//=============================================
// ARCHELIOS MAP NAMESPACE
//=============================================
var am = (function(module) {

    //Use strict mode
    'use strict';

    /**
     * @class am.InfoPanelView
     * This class implements a responsive side panel displaying information about the selected feature(s).
     */
    module.InfoPanelView = am.PanelView.extend({
        // Public attributes
        options: {
            pvPanelYield:           0.155, // yield of the PV panels (= kWc/m²)
            maxROIForProfitability: 20     // years
        },

        // Private attributes
        _panelElementPromise: am.utils.controllablePromise(), // Promise evaluating to the contents of the panel
        _sliderElementsPromise: am.utils.controllablePromise(), // Promise evaluating to the slider elements (not the DOM elements, but the JS objects!)
        _knobElementsPromise: am.utils.controllablePromise(), // Promise evaluating to the slider elements (not the DOM elements, but the JS objects!)
        _breadCrumbPreviousButtons: {
            "am-home-section":                                [],
            "am-electricity-info-section":                    ["am-home-section"],
            "am-autoconsumption-info-section":                ["am-home-section", "am-electricity-info-section"],
            "am-electricity-production-results-section":      ["am-home-section", "am-electricity-info-section"],
            "am-electricity-autoconsumption-results-section": ["am-home-section", "am-electricity-info-section", "am-autoconsumption-info-section"],
            "am-hot-water-info-section":                      ["am-home-section"],
            "am-hot-water-production-results-section":        ["am-home-section", "am-hot-water-info-section"],
            "am-electricity-go-further-section":              ["am-home-section", "am-electricity-info-section", "am-electricity-production-results-section"],
            "am-autoconsumption-go-further-section":          ["am-home-section", "am-electricity-info-section", "am-autoconsumption-info-section", "am-electricity-autoconsumption-results-section"],
            "am-hot-water-go-further-section":                ["am-home-section", "am-hot-water-info-section", "am-hot-water-production-results-section"]
        },
        _hotWaterResultPanelIds : {
            standardPanel: "am-hot-water-production-equivalent",
            noInstallationPanel: "am-hot-water-no-production"
        },
        _currPageId: undefined,
        _previousPageId: undefined,
        _setupType: undefined,

        /**
         * Class constructor
         * @constructor
         *
         * @param {Object} options - Same options as for class am.PanelView
         */
        initialize: function(options) {
            // Call to parent method
            am.PanelView.prototype.initialize.call(this, options);
            
            // Fill the panel container with the appropriate contents
            var self = this;
            am.templateManager.fillElementWithTemplate(this._container, 'feature-information-panel', options.templateParameters,
                function($container) {
                    // Add the modal windows to the panel container
                    $(document.body).append('<div id="am-panel-modal"></div>'); // modal window displaying more information to the interested reader
                    $(document.body).append('<div id="am-share-modal"></div>'); // modal window appearing when clicking on the "share" button

                    // Resolve the panel element promise
                    self._panelElementPromise.resolve($container.children().eq(0));

                    // Create the sliders
                    var sliders = [];
                    $('.am-solar-panel-surface-slider').each(function(index, element) {
                        var $element = $(element);
                        var slider = $element.bootstrapSlider({
                            formatter: function(value) {
                                return value.toFixed(0) + " " + am.translator.translate($element.attr('data-unit'));
                            }
                        });

                        // Get the slider type
                        slider.installationType = $element.closest('.am-thermal-panel-slider').length > 0 ? 'thermal' : 'pv';

                        // Display the peak power below the PV surface
                        var displayPeakPower = function() {
                            var peakPower = self.options.pvPanelYield * slider.bootstrapSlider('getValue'); // in kWc
                            var $toolTipElement = $(slider.bootstrapSlider('getElement')).find('.tooltip .tooltip-inner');
                            $toolTipElement.attr('data-peakpower', "(" + am.translator.formatNumber(peakPower, 1) + " " + am.translator.translate('kWc') + ")");
                        };
                        displayPeakPower();
                        slider.on('slide change', displayPeakPower);
                        slider.updatePeakPower = displayPeakPower;

                        // Add a div over the slider tooltip in order to show the "computation in progress" message
                        var $toolTip = $(slider.bootstrapSlider('getElement')).find('.tooltip.tooltip-main');
                        var $progressDiv = $('<div>').addClass('am-irradiation-computation-in-progress');
                        $progressDiv.html('<i class="fa-fw fa fa-gear fa-spin"></i>' + am.translator.translate('computationInProgress'));
                        $progressDiv.hide();
                        $progressDiv.appendTo($toolTip);
                        
                        sliders.push(slider);
                    });
                    self._sliderElementsPromise.resolve(sliders);

                    //
                    // var knobs = [];
                    // $('.am-knob-input').each(function(index, element) {
                    //     var $element = $(element);
                    //     // console.log($element);
                    //
                    //     var _sUnit = '';
                    //     if ($element.attr('data-unit')) {
                    //         _sUnit = ' '+$element.attr('data-unit');
                    //     }
                    //
                    //     var knob = $element.knob({
                    //         min: 0,
                    //         max: 100,
                    //         step: 10,
                    //         width: 50,
                    //         height: 50,
                    //         fgColor:"#ffc000",
                    //         bgColor:"#ffffff",
                    //         inputColor: '#ffc000',
                    //         release : function (v) {
                    //             // var _event = new Event();
                    //             console.log(this);
                    //             console.log(v);
                    //             var e = jQuery.Event('knob_changed', {
                    //                 target: this.$div,
                    //                 value: v
                    //             });
                    //             $element.attr('data-value', v);
                    //             $element.attr('value', v);
                    //             am.eventManager.trigger('knob_changed', e);
                    //             // $element.trigger('change', v);
                    //         },
                    //         format: function(value) {
                    //             return value+_sUnit;
                    //         }
                    //         // skin:"tron",
                    //         // cursor:true
                    //     });
                    //
                    //     knob.addClass('am-knob');
                    //
                    //     knobs.push(knob);
                    // });
                    // self._knobElementsPromise.resolve(knobs);

                    // Hide the panel to be displayed in case the installation of thermal solar modules
                    // is not advisable (e.g. in case the user does not heat his water with electricity)
                    $container.find('#' + self._hotWaterResultPanelIds.noInstallationPanel).hide();
                });

            return this;
        },

        setSliderRange: function(minValue, maxValue, sliderType) {
            sliderType = sliderType === undefined ? 'all' : sliderType;
            this._sliderElementsPromise.then(function(sliders) {
                sliders.forEach(function(slider) {
                    if (sliderType === 'all' || sliderType === slider.installationType) {
                        var currValue = slider.bootstrapSlider('getValue');
                        if (currValue < minValue || currValue > maxValue) {
                            currValue = 0.5 * (minValue + maxValue);
                        }
                        slider.bootstrapSlider('setAttribute', 'min', minValue);
                        slider.bootstrapSlider('setAttribute', 'max', maxValue);
                        slider.bootstrapSlider('setValue', currValue, false, false); // update display even if the value did not change
                        slider.updatePeakPower();
                        slider.bootstrapSlider('relayout');
                    }
                });
            });
        },

        setSliderValue: function(value, sliderType) {
            sliderType = sliderType === undefined ? 'all' : sliderType;
            this._sliderElementsPromise.then(function(sliders) {
                sliders.forEach(function(slider) {
                    if (sliderType === 'all' || sliderType === slider.installationType) {
                        var minValue = slider.bootstrapSlider('getAttribute', 'min');
                        var maxValue = slider.bootstrapSlider('getAttribute', 'max');
                        value = Math.max(Math.min(value, maxValue), minValue); // limit value to the range [minValue, maxValue]
                        slider.bootstrapSlider('setValue', value, false, false); // update display even if the value did not change
                        slider.updatePeakPower();
                        slider.bootstrapSlider('relayout');
                    }
                });
            });
        },

        getSliderValue: function() {
            return this._sliderElementsPromise.then(function(sliders) {
                return sliders[0].bootstrapSlider('getValue');
            });
        },

        displayPage: function(pageId, previousPageId) {

            var $container = $(this._container);
            var $panelBody = $container.find('.am-panel-body');

            // Read More button
            $panelBody.find('.page-expanded').removeClass('page-expanded');
            $panelBody.find('.fadeout-paragraph.fadeout-paragraph-off, .fadeout-paragraph-xl.fadeout-paragraph-off').removeClass('fadeout-paragraph-off');

            // Strip off the '#' character at the beginning of the page ID if present
            if (pageId[0] == '#') {
                pageId = pageId.substr(1);
            }

            // Exit function (do nothing) of the page did not change
            if (pageId == this._currPageId) {
                return;
            }

            if (pageId != 'am-previous-section') {
                // Update the current page ID
                previousPageId = (previousPageId == undefined) ? this._currPageId : previousPageId;
                this.setCurrentPageId(pageId);
                this._previousPageId = previousPageId;
            } else { // previous button
                this.setCurrentPageId(this._previousPageId);
                var _bpb = this._breadCrumbPreviousButtons[this._currPageId];
                if (_bpb.length) {
                    this._previousPageId = _bpb[_bpb.length - 1];
                }
            }

            // Hide all pages
            var $pages = $container.find('.page');
            $pages.hide();
            $('.am-panel-body section').removeClass('active');

            // Display/hide messages associated with the thermal installations
            if (this._setupType !== undefined && this._setupType == "hot-water") {
                $('.hide-if-not-thermal').removeClass('hidden');
                $('.show-if-not-thermal').addClass('hidden');
            } else {
                $('.hide-if-not-thermal').addClass('hidden');
                $('.show-if-not-thermal').removeClass('hidden');
            }

            // Get the height of the page to be displayed
            var bodyHeight = $panelBody.height();

            // Handle the display of the right content depending on the user type (individual, professional, administration)
            var $selectedPage = $pages.filter('#' + this._currPageId);
            var sUserType = this.getUserProfile(); //#2404
            $selectedPage.find('.update-trans').each(function() {
                // Show the right content and hide the others
                $( this ).find( '[data-trans-type]:not([data-trans-type~="' + sUserType + '"])').addClass('hidden');
                $( this ).find( '[data-trans-type~="' + sUserType + '"]').removeClass('hidden');
            });

            // Display the selected page
            $selectedPage.show();
            $selectedPage.closest('section').addClass('active');

            // Activate and display the correct buttons in the bread crumb
            var previousPageIds = this._breadCrumbPreviousButtons[this._currPageId];

            $selectedPage.find('.read-more button').off('click');
            $selectedPage.find('.read-more button').on('click', function(e) {
                e.preventDefault();
                e.stopPropagation();
                var $paragraph = $(this).closest('.fadeout-paragraph, .fadeout-paragraph-xl');
                if ($paragraph.hasClass('fadeout-paragraph-off')) {
                    $paragraph.removeClass('fadeout-paragraph-off');
                    $paragraph.closest('section').removeClass('page-expanded');
                } else {
                    $paragraph.addClass('fadeout-paragraph-off');
                    $paragraph.closest('section').addClass('page-expanded');
                }
            });

            // var knobs = [];
            $('.am-rate-container').each(function(index, element) {
                var $element = $(element);

                $element.find('.am-electricity-production-borrow-more').off('click');
                $element.find('.am-electricity-production-borrow-more').on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // console.log('caught click on borrow more');

                    var _$res = $element.find('.am-computation-result');
                    var _$resVal = _$res.attr('data-value');
                    var _$resUnit = _$res.attr('data-unit');
                    var _$resPrecision = _$res.attr('data-precision');

                    var _nResVal = 0;
                    if (100 >= parseInt(_$resVal) >= 0) {
                        _nResVal = parseInt(_$resVal);
                        if ((_nResVal >= 0) && (_nResVal < 100))
                            _nResVal = _nResVal + 10;
                    }

                    _$res.attr("data-value",_nResVal);
                    // _$res.html(_nResVal.toFixed(_$resPrecision) + " " + am.translator.translate(_$resUnit));

                    var e = jQuery.Event('knob_changed', {
                        target: $element,
                        value: _nResVal
                    });
                    am.eventManager.trigger('knob_changed', e);
                });
                $element.find('.am-electricity-production-borrow-less').off('click');
                $element.find('.am-electricity-production-borrow-less').on('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    // console.log('caught click on borrow less');

                    var _$res = $element.find('.am-computation-result');
                    var _$resVal = _$res.attr('data-value');
                    var _$resUnit = _$res.attr('data-unit');
                    var _$resPrecision = _$res.attr('data-precision');

                    var _nResVal = 0;
                    if (100 >= parseInt(_$resVal) >= 0) {
                        _nResVal = parseInt(_$resVal);
                        if ((_nResVal >= 10) && (_nResVal <= 100))
                            _nResVal = _nResVal - 10;
                    }

                    _$res.attr("data-value",_nResVal);
                    // _$res.html(_nResVal.toFixed(_$resPrecision) + " " + am.translator.translate(_$resUnit));

                    var e = jQuery.Event('knob_changed', {
                        target: $element,
                        value: _nResVal
                    });
                    am.eventManager.trigger('knob_changed', e);
                });

                // knobs.push($element);
            });
            // self._knobElementsPromise.resolve(knobs);

            this._displayBreadCrumbButtons(previousPageIds, this._currPageId);

            am.eventManager.trigger('new-page-displayed', pageId);
        },

        formatComputationResult: function(results, data) {
            var self = this;

            // Get property name
            var name = data['id'];

            // Get property value
            var value = results[name];
            switch(name) {
                case "electricityAutoconsumptionPercentage":
                    value = results['electricityAutoconsumptionRate'] * 100.;
                    break;
                case "electricityAutoproductionPercentage":
                    value = results['electricityAutoproductionRate'] * 100.;
                    break;
                case "thermalPanelDailyHotWaterVolumeProduction":
                    value = results.dailyHotWaterVolumeProduction; // in L
                    break;
                case "thermalPanelAnnualHotWaterVolumeProduction":
                    value = results.annualHotWaterVolumeProduction / 1000.; // in m3
                    break;
                case "thermalPanelAnnualNeedsCoveragePercentage":
                    value = results.annualNeedsCoverageRate * 100.;
                    break;
                case "combinedAnnualHotWaterNeedsCoverageRate":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].annualHotWaterNeedsCoverageRate * 100. : undefined;
                    break;
                case "combinedAnnualHeatNeedsCoverageRate":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].annualHeatNeedsCoverageRate * 100. : undefined;
                    break;
                case "installPeakPower":
                    value = results.installPeakPower / 1000.; // kWc
                    break;

                /**
                 * SALE AREA
                 */
                case "pvElecSaleBorrow":
                    value = results.economicsResults['sale'].borrowedAmount;
                    break;
                case "pvElecSaleBorrowedPercentage":
                    value = results.economicsResults['sale'].borrowedPercentage*100;
                    break;
                case "pvElecSaleAnnualBillSavings":
                    value = (results.economicsResults['sale'].billSavingsOverPeriod) / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleTotalBillSavings":
                    value = results.economicsResults['sale'].billSavingsOverPeriod;
                    break;
                case "pvElecSaleTotalIncome":
                    value = results.economicsResults['sale'].incomingOverPeriod;
                    break;
                case "pvElecSaleTotalSpendings":
                    value = results.economicsResults['sale'].spendingsOverPeriod;
                    break;
                case "pvElecSaleTotalMaintenance":
                    value = results.economicsResults['sale'].maintenanceCostOverPeriod;
                    break;
                case "pvElecSaleTotalCreditLoan":
                    value = results.economicsResults['sale'].creditAmount;
                    break;
                case "pvElecSaleTotalCreditCost":
                    value = results.economicsResults['sale'].creditCost;
                    break;
                case "pvElecSaleOwnFunds":
                    value = results.economicsResults['sale'].ownFunds;
                    break;
                case "pvElecSaleTotalProfits":
                    value = results.economicsResults['sale'].netProfitOverPeriod;
                    break;
                case "pvElecSaleRawTotalProfits":
                    value = results.economicsResults['sale'].rawProfitOverPeriod;
                    break;
                case "pvElecSaleRawInstallationCost":
                    value = results.economicsResults['sale'].rawInstallationCost;
                    break;
                case "pvElecSaleInstallationCost":
                    value = results.economicsResults['sale'].installationCost;
                    break;
                case "pvElecSaleSubventions":
                    value = results.economicsResults['sale'].totalSubventionOverPeriod;
                    break;
                case "pvElecSaleYearlyIncome":
                    value = results.economicsResults['sale'].incomingOverPeriod / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyNetIncome":
                    value = Math.max(0, results.economicsResults['sale'].incomingOverPeriod - results.economicsResults['sale'].spendingsOverPeriod) /
                        results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyProfits":
                    value = (results.economicsResults['sale'].netProfitOverPeriod) / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyRawProfits":
                    value = results.economicsResults['sale'].rawProfitOverPeriod / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyCreditLoan":
                    value = results.economicsResults['sale'].creditAmount / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyOwnFunds":
                    value = results.economicsResults['sale'].ownFunds / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlySpendings":
                    value = (results.economicsResults['sale'].spendingsOverPeriod) / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyMaintenance":
                    value = Math.max(0, results.economicsResults['sale'].maintenanceCostOverPeriod) / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleYearlyInvestment":
                    value = (results.economicsResults['sale'].ownFunds + results.economicsResults['sale'].creditAmount) / results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSaleReturnOnInvestment":
                    value = results.economicsResults['sale'].returnOnInvestment;
                    break;
                case "pvElecSaleRaccordement":
                    value = results.economicsResults['sale'].electricityConnectionCostOverPeriod;
                    break;
                case "pvElecSaleInstallWoRaccordement":
                    value = results.economicsResults['sale'].electricityCostWoConnection;
                    break;
                case "pvElecSaleObservationPeriod":
                    value = results.economicsResults['sale'].observationPeriod;
                    break;
                case "pvElecSalePercentageOfReturn":
                    value = results.economicsResults['sale'].rateOfReturn * 100;
                    break;

                /**
                 * AUTOCONSO AREA
                 */
                case "pvAutoconsoBorrow":
                    value = results.economicsResults['bestAuto'].borrowedAmount;
                    break;
                case "pvAutoconsoBorrowedPercentage":
                    value = results.economicsResults['bestAuto'].borrowedPercentage*100;
                    break;
                case "pvAutoconsoTotalBillSavings":
                    value = results.economicsResults['bestAuto'].billSavingsOverPeriod;
                    break;
                case "pvAutoconsoTotalIncome":
                    value = results.economicsResults['bestAuto'].incomingOverPeriod;
                    break;
                case "pvAutoconsoTotalSpendings":
                    value = results.economicsResults['bestAuto'].spendingsOverPeriod;
                    break;
                case "pvAutoconsoTotalMaintenance":
                    value = results.economicsResults['bestAuto'].maintenanceCostOverPeriod;
                    break;
                case "pvAutoconsoTotalCreditLoan":
                    value = results.economicsResults['bestAuto'].creditAmount;
                    break;
                case "pvAutoconsoTotalCreditCost":
                    value = results.economicsResults['bestAuto'].creditCost;
                    break;
                case "pvAutoconsoOwnFunds":
                    value = results.economicsResults['bestAuto'].ownFunds;
                    break;
                case "pvAutoconsoTotalProfits":
                    value = results.economicsResults['bestAuto'].netProfitOverPeriod;
                    break;
                case "pvAutoconsoTotalSavings":
                    value = results.economicsResults['bestAuto'].billSavingsOverPeriod;
                    break;
                case "pvAutoconsoRawTotalProfits":
                    value = results.economicsResults['bestAuto'].rawProfitOverPeriod;
                    break;
                case "pvAutoconsoRawInstallationCost":
                    value = results.economicsResults['bestAuto'].rawInstallationCost;
                    break;
                case "pvAutoconsoInstallationCost":
                    value = results.economicsResults['bestAuto'].installationCost;
                    break;
                case "pvAutoconsoSubventions":
                    value = results.economicsResults['bestAuto'].totalSubventionOverPeriod;
                    break;
                case "pvAutoconsoYearlyIncome":
                    value = results.economicsResults['bestAuto'].incomingOverPeriod / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyNetIncome":
                    value = Math.max(0, results.economicsResults['bestAuto'].incomingOverPeriod - 0.5 * results.economicsResults['bestAuto'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['bestAuto'].billSavingsOverPeriod - 0.5 * results.economicsResults['bestAuto'].spendingsOverPeriod)) /
                        results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlySavings":
                    value = results.economicsResults['bestAuto'].billSavingsOverPeriod / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyNetSavings":
                    value = Math.max(0, results.economicsResults['bestAuto'].billSavingsOverPeriod - 0.5 * results.economicsResults['bestAuto'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['bestAuto'].incomingOverPeriod - 0.5 * results.economicsResults['bestAuto'].spendingsOverPeriod)) /
                        results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyNetSavingsPlusIncome":
                    value = Math.max(0, results.economicsResults['bestAuto'].billSavingsOverPeriod + results.economicsResults['bestAuto'].incomingOverPeriod -
                        results.economicsResults['bestAuto'].spendingsOverPeriod) / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyProfits":
                    value = (results.economicsResults['bestAuto'].netProfitOverPeriod) / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyRawProfits":
                    // var creditCost = results.creditCost;
                    value = results.economicsResults['bestAuto'].rawProfitOverPeriod / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyCreditLoan":
                    value = results.economicsResults['bestAuto'].creditAmount / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyOwnFunds":
                    // console.log(creditCost);
                    value = results.economicsResults['bestAuto'].ownFunds / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlySpendings":
                    value = (results.economicsResults['bestAuto'].spendingsOverPeriod) / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyMaintenance":
                    value = Math.max(0, results.economicsResults['bestAuto'].maintenanceCostOverPeriod) / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoYearlyInvestment":
                    value = (results.economicsResults['bestAuto'].ownFunds + results.economicsResults['bestAuto'].creditAmount) / results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoReturnOnInvestment":
                    value = results.economicsResults['bestAuto'].returnOnInvestment;
                    break;
                case "pvAutoconsoRaccordement":
                    value = results.economicsResults['bestAuto'].electricityConnectionCostOverPeriod;
                    break;
                case "pvAutoconsoInstallWoRaccordement":
                    value = results.economicsResults['bestAuto'].electricityCostWoConnection;
                    break;
                case "pvAutoconsoObservationPeriod":
                    value = results.economicsResults['bestAuto'].observationPeriod;
                    break;
                case "pvAutoconsoPercentageOfReturn":
                    value = results.economicsResults['bestAuto'].rateOfReturn * 100;
                    break;

                /**
                 * THERMAL PANEL AREA
                 */
                case "thermalPanelBorrow":
                    value = results.economicsResults['thermal'].borrowedAmount;
                    break;
                case "thermalPanelBorrowedPercentage":
                    value = results.economicsResults['thermal'].borrowedPercentage*100;
                    break;
                case "thermalPanelTotalBillSavings":
                    value = results.economicsResults['thermal'].billSavingsOverPeriod;
                    break;
                case "thermalPanelTotalIncome":
                    value = results.economicsResults['thermal'].incomingOverPeriod;
                    break;
                case "thermalPanelTotalSpendings":
                    value = results.economicsResults['thermal'].spendingsOverPeriod;
                    break;
                case "thermalPanelTotalMaintenance":
                    value = results.economicsResults['thermal'].maintenanceCostOverPeriod;
                    break;
                case "thermalPanelTotalCreditLoan":
                    value = results.economicsResults['thermal'].creditAmount;
                    break;
                case "thermalPanelTotalCreditCost":
                    value = results.economicsResults['thermal'].creditCost;
                    break;
                case "thermalPanelOwnFunds":
                    value = results.economicsResults['thermal'].ownFunds;
                    break;
                case "thermalPanelTotalProfits":
                    value = results.economicsResults['thermal'].netProfitOverPeriod;
                    break;
                case "thermalPanelTotalSavings":
                    value = results.economicsResults['thermal'].billSavingsOverPeriod;
                    break;
                case "thermalPanelRawTotalProfits":
                    value = results.economicsResults['thermal'].rawProfitOverPeriod;
                    break;
                case "thermalPanelRawInstallationCost":
                    value = results.economicsResults['thermal'].rawInstallationCost;
                    break;
                case "thermalPanelInstallationCost":
                    value = results.economicsResults['thermal'].installationCost;
                    break;
                case "thermalPanelSubventions":
                    value = results.economicsResults['thermal'].totalSubventionOverPeriod;
                    break;
                case "thermalPanelYearlyIncome":
                    value = results.economicsResults['thermal'].incomingOverPeriod / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyNetIncome":
                    value = Math.max(0, results.economicsResults['thermal'].incomingOverPeriod - 0.5 * results.economicsResults['thermal'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['thermal'].billSavingsOverPeriod - 0.5 * results.economicsResults['thermal'].spendingsOverPeriod)) /
                        results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlySavings":
                    value = results.economicsResults['thermal'].billSavingsOverPeriod / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyNetSavings":
                    value = Math.max(0, results.economicsResults['thermal'].billSavingsOverPeriod - 0.5 * results.economicsResults['thermal'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['thermal'].incomingOverPeriod - 0.5 * results.economicsResults['thermal'].spendingsOverPeriod)) /
                        results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyProfits":
                    value = (results.economicsResults['thermal'].netProfitOverPeriod) / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyRawProfits":
                    value = results.economicsResults['thermal'].rawProfitOverPeriod / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyCreditLoan":
                    value = results.economicsResults['thermal'].creditAmount / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyOwnFunds":
                    value = results.economicsResults['thermal'].ownFunds / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlySpendings":
                    value = (results.economicsResults['thermal'].spendingsOverPeriod) / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyMaintenance":
                    value = (results.economicsResults['thermal'].maintenanceCostOverPeriod) / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelYearlyInvestment":
                    value = (results.economicsResults['thermal'].ownFunds + results.economicsResults['thermal'].creditAmount) / results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelReturnOnInvestment":
                    value = results.economicsResults['thermal'].returnOnInvestment;
                    break;
                case "thermalPanelRaccordement":
                    value = results.economicsResults['thermal'].electricityConnectionCostOverPeriod;
                    break;
                case "thermalPanelInstallWoRaccordement":
                    value = results.economicsResults['thermal'].electricityCostWoConnection;
                    break;
                case "thermalPanelObservationPeriod":
                    value = results.economicsResults['thermal'].observationPeriod;
                    break;
                case "thermalPanelPercentageOfReturn":
                    value = results.economicsResults['thermal'].rateOfReturn * 100;
                    break;

                /**
                 * COMBINED AREA
                 */

                case "combinedPanelSurface":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].panelSurface : undefined;
                    break;
                case "combinedBorrow":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].borrowedAmount : undefined;
                    break;
                case "combinedBorrowedPercentage":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].borrowedPercentage*100 : undefined;
                    break;
                case "combinedTotalIncome":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].incomingOverPeriod : undefined;
                    break;
                case "combinedTotalSpendings":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].spendingsOverPeriod : undefined;
                    break;
                case "combinedTotalMaintenance":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].maintenanceCostOverPeriod : undefined;
                    break;
                case "combinedTotalCreditLoan":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].creditAmount : undefined;
                    break;
                case "combinedTotalCreditCost":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].creditCost : undefined;
                    break;
                case "combinedOwnFunds":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].ownFunds : undefined;
                    break;
                case "combinedTotalProfits":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].netProfitOverPeriod : undefined;
                    break;
                case "combinedTotalSavings":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].billSavingsOverPeriod : undefined;
                    break;
                case "combinedRawTotalProfits":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].rawProfitOverPeriod : undefined;
                    break;
                case "combinedRawInstallationCost":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].rawInstallationCost : undefined;
                    break;
                case "combinedInstallationCost":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].installationCost : undefined;
                    break;
                case "combinedSubventions":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].totalSubventionOverPeriod : undefined;
                    break;
                case "combinedYearlyIncome":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].incomingOverPeriod / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyNetIncome":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? Math.max(0, results.economicsResults['combined'].incomingOverPeriod -
                        0.5 * results.economicsResults['combined'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['combined'].billSavingsOverPeriod - 0.5 * results.economicsResults['combined'].spendingsOverPeriod)) /
                        results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlySavings":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].billSavingsOverPeriod / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyNetSavings":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? Math.max(0, results.economicsResults['combined'].billSavingsOverPeriod -
                        0.5 * results.economicsResults['combined'].spendingsOverPeriod +
                        Math.min(0, results.economicsResults['combined'].incomingOverPeriod - 0.5 * results.economicsResults['combined'].spendingsOverPeriod)) /
                        results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyProfits":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? (results.economicsResults['combined'].netProfitOverPeriod) / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyRawProfits":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].rawProfitOverPeriod / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyCreditLoan":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].creditAmount / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyOwnFunds":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].ownFunds / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlySpendings":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? (results.economicsResults['combined'].spendingsOverPeriod) / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyMaintenance":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? (results.economicsResults['combined'].maintenanceCostOverPeriod) / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedYearlyInvestment":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? (results.economicsResults['combined'].ownFunds + results.economicsResults['combined'].creditAmount) / results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedReturnOnInvestment":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].returnOnInvestment : undefined;
                    break;
                case "combinedRaccordement":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].electricityConnectionCostOverPeriod : undefined;
                    break;
                case "combinedInstallWoRaccordement":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].electricityCostWoConnection : undefined;
                    break;
                case "combinedObservationPeriod":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].observationPeriod : undefined;
                    break;
                case "combinedPercentageOfReturn":
                    value = (results.economicsResults.hasOwnProperty('combined')) ? results.economicsResults['combined'].rateOfReturn * 100 : undefined;
                    break;

                // case "combinedPanelBorrow":
                //     value = results.combinedPanelBorrow;
                //     break;
                // case "combinedPanelBorrowedPercentage":
                //     value = results.combinedPanelBorrowedPercentage*100;
                //     break;
				// case "annualCombinedBillSavings":// #2963
				// 	value = (results.combinedBillSavingsOverPeriod - results.combinedMaintenanceCostOverPeriod) / results.combinedPanelObservationPeriod;
                //     break;
                // case "totalCombinedBillSavings":
                //     var annualCombinedBillSavings = (results.combinedBillSavingsOverPeriod - results.combinedMaintenanceCostOverPeriod) / results.combinedPanelObservationPeriod
                //     value = annualCombinedBillSavings * results.creditPeriod;
                //     break;
                // case "totalCombinedProfits":
                //     var creditCost = results.creditCost;
                //     value = results.combinedNetProfit - creditCost;
                //     break;
            }

            // Get property units
            var units = data['unit'];
            switch(units) {
                case "person":
                    units = (Math.round(value) > 1) ? am.translator.translate('personnes') : am.translator.translate('personne');
                    break;
                case "year":
                    units = (Math.round(value) > 1) ? am.translator.translate('years') : am.translator.translate('year');
                    break;
                case "currency":
                    units = am.translator.translate('€');
                    break;
                case "currencyPerYear":
                    units = am.translator.translate('€_par_an');
                    break;
                case "m2":
                    units = am.translator.translate('m2Module');
                    break;
                case "kWh":
                    units = am.translator.translate('kWh');
                    break;
                case "kg":
                    units = am.translator.translate('kg');
                    break;
                case "kWhPerYear":
                    units = am.translator.translate('kWh_per_year');
                    break;
                case "kgPerYear":
                    units = am.translator.translate('kg_per_year');
                    break;
                case "LPeryear":
                    units = am.translator.translate('L_per_year');
                    break;
                case "m3PerYear":
                    units = am.translator.translate('m3_per_year');
                    break;
                case "m3":
                    units = am.translator.translate('m3');
                    break;
            }
            units = (units === "" || units === "%") ? units : " " + units; // add space before units

            // Check the property value
            var formattedValue = value;
            if (value == undefined || isNaN(value)) {
                value = undefined;
                formattedValue = "&mdash;";
            } else if (typeof value === 'number') {
                var precision = data['precision']; // precision de l'affichage (nombre de chiffres après la virgule)
                value = Math.max(0, value); // all values in Archelios MAP are positive!
                formattedValue = am.translator.formatNumber(value, precision);
                if (formattedValue == "0" && data['unit'] == "person") {
                    formattedValue = am.translator.translate('lessThanOne');
                }
            }

            return {value: formattedValue, units: units, rawValue: value};
        },

        setComputationResults: function(results, oDataBindings) {
            var self = this;
            var $container = $(this._container);

            console.log(results);

            // Update the slider limits
            this.setSliderRange(6, results.maxAvailablePanelSurface.pv, 'pv');
            this.setSliderRange(2, results.maxAvailablePanelSurface.thermal, 'thermal');

            // #2963
            var oUserInfo =self.getUserInputs();
            var resultsPage = $("#am-hot-water-production-results-section");
            if(oUserInfo.thermalType=="combined"){
                resultsPage.find('.hide-if-not-conbined').removeClass('hidden');
                resultsPage.find('.show-if-not-conbined').addClass('hidden');
            }else{
                resultsPage.find('.hide-if-not-conbined').addClass('hidden');
                resultsPage.find('.show-if-not-conbined').removeClass('hidden');
            }
           
            // Update the contents of the DOM elements
            $('.am-computation-result').each(function(index, element) {
                var $element = $(element);

                // Get property name
                var name = $element.attr('data-name');
                var units = $element.attr('data-unit') || "";
                var precision = parseInt($element.attr('data-precision')) || 0; // precision de l'affichage (nombre de chiffres après la virgule)

                var data = null;

                if (oDataBindings.hasOwnProperty(name))
                    data = oDataBindings[name];
                else {
                    console.log('Attribute not found : ' + name);
                }

                var res = self.formatComputationResult(results, data);
                // console.log(res)
              
                var value = res.rawValue;
                switch(name) {
                    case "pvElecSaleReturnOnInvestment":
                        var $resultsPage = $("#am-electricity-production-results-section");
                        if (value > self.options.maxROIForProfitability) {
                            $resultsPage.find('.hide-if-not-profitable').addClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').removeClass('hidden');
                        } else {
                            $resultsPage.find('.hide-if-not-profitable').removeClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').addClass('hidden');
                        }
                        break;
                    case "pvAutoconsoReturnOnInvestment":
                        var $resultsPage = $("#am-electricity-autoconsumption-results-section");
                        if (value > self.options.maxROIForProfitability) {
                            $resultsPage.find('.hide-if-not-profitable').addClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').removeClass('hidden');
                        } else {
                            $resultsPage.find('.hide-if-not-profitable').removeClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').addClass('hidden');
                        }
                        break;
                    case "thermalPanelReturnOnInvestment":
                        var $resultsPage = $("#am-hot-water-production-results-section .show-if-not-conbined");
                        if (value > self.options.maxROIForProfitability) {
                            $resultsPage.find('.hide-if-not-profitable').addClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').removeClass('hidden');
                        } else {
                            $resultsPage.find('.hide-if-not-profitable').removeClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').addClass('hidden');
                        }
                        break;
                    case "combinedReturnOnInvestment":
                        var $resultsPage = $("#am-hot-water-production-results-section .hide-if-not-conbined");
                        if (value > self.options.maxROIForProfitability) {
                            $resultsPage.find('.hide-if-not-profitable').addClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').removeClass('hidden');
                        } else {
                            $resultsPage.find('.hide-if-not-profitable').removeClass('hidden');
                            $resultsPage.find('.show-if-not-profitable').addClass('hidden');
                        }
                        break;
                    /*case "pvElecSaleBorrowedPercentage":
                        // var $resultsPage = $(".pvElecSaleBorrowedPercentage");
                        $element.attr('data-value', res.value);
                        break;
                    case "pvAutoconsoBorrowedPercentage":
                        // var $resultsPage = $(".pvElecSaleBorrowedPercentage");
                        $element.attr('data-value', res.value);
                        break;
                    case "combinedBorrowedPercentage":
                        // var $resultsPage = $(".pvElecSaleBorrowedPercentage");
                        $element.attr('data-value', res.value);
                        break;*/
                }

                $element.html(res.value + ' ' + res.units);

                if (name === 'thermalPanelYearlyRawProfits') {
                    var $parentElement = $element.parents('.am-panel-result-item').eq(0);
                    if (res.value <= 0) {
                        $parentElement.addClass('hidden');
                    } else {
                        $parentElement.removeClass('hidden');
                    }
                }
            });

            // Compute Popups computed attributes
            $(".am-computation-result-popup").each(function(index, element) {
                var $element = $(element);

                var _oDataAttrs = $element.data();

                // console.log(_oDataAttrs);
                // console.log('----------------');
                var oDataAttrIds = _.keys(_oDataAttrs);
                for (var i=0; i<oDataAttrIds.length; i++) {
                    var oDataAttrId = oDataAttrIds[i];
                    var oDataAttrVal = _oDataAttrs[oDataAttrId];
                    var data = null;

                    // console.log(oDataAttrId);
                    if (oDataBindings.hasOwnProperty(oDataAttrId))
                        data = oDataBindings[oDataAttrId];
                    else {
                        console.log('Attribute not found : ' + oDataAttrId);
                    }

                    if (data) {
                        var res = self.formatComputationResult(results, data);
                        // console.log(res);

                        var rmultiDash = /([a-z])([A-Z])/g;
                        var oDataAttrIdFormatted = "data-" + oDataAttrId.replace( rmultiDash, "$1-$2" ).toLowerCase();
                        // console.log(oDataAttrIdFormatted);
                        $element.attr(oDataAttrIdFormatted,res.value + ' ' + res.units);
                    }
                }

            });
        },

        setUserInputs: function(userInputs) {
            var _this = this;
            return new Promise(function(resolve, reject) {
                var _pUserInputsAllA = [];

                _.each(userInputs, function (value, key) {
                    var _pUserInput = new Promise(function (_resolve, _reject) {
                        var value = userInputs[key];
                        var $formElements = $('form input[name="' + key + '"]');
                        if ($formElements.length > 0) {
                            var type = $formElements.eq(0).attr('type');
                            if (type == 'radio') {
                                $formElements.prop('checked', false);
                                var $elementToCheck = $formElements.filter('[value="' + value + '"]');
                                $elementToCheck.prop('checked', true);
                                $elementToCheck.trigger('change');
                                _resolve(userInputs);
                            } else if (type == 'checkbox') {
                                if (!value) {
                                    $formElements.removeAttr('checked');
                                } else if (value) {
                                    $formElements.attr('checked', 'checked');
                                }
                                _resolve(userInputs);
                            } else if (type == 'number' && $formElements.eq(0).attr('data-provide') == "slider") {
                                var sliderType = $formElements.eq(0).closest('.am-thermal-panel-slider').length > 0 ? 'thermal' : 'pv';
                                _this._sliderElementsPromise.then(function (sliders) {
                                    sliders.forEach(function (slider) {
                                        if (slider.installationType === sliderType) {
                                            if (slider.bootstrapSlider('getAttribute', 'max') < value) {
                                                slider.bootstrapSlider('setAttribute', 'max', value + 10);
                                            }
                                            slider.bootstrapSlider('setValue', value, false, false);
                                            slider.updatePeakPower();
                                            slider.bootstrapSlider('relayout');
                                        }
                                    });
                                    _resolve(userInputs);
                                });
                            } else if (type == 'number') {
                                $formElements.val(value);
                                _resolve(userInputs);
                            } else if (type == 'text') {
                                $formElements.val(value);
                                if ($formElements.hasClass('am-knob-input')) {
                                    $formElements.trigger('change');
                                }
                                _resolve(userInputs);
                            }
                        } else {
                            var $formSelects = $('select[name="' + key + '"]');
                    		if($formSelects.length > 0){
                                $formSelects.val(userInputs[key]);
                    		} else {
                    		    var $formRates = $('form .am-rate-container span[data-name="' + key + '"]');
                                if ($formRates.length > 0) {
                                    $formRates.attr('data-value', userInputs[key]);
                                }
                            }
                            _resolve(userInputs);
                        }
						
						if(key=="thermalType")// #2963
                    		_this.updateThermalView(userInputs[key]);
                    });
                    _pUserInputsAllA.push(_pUserInput);
                });

                Promise.all(_pUserInputsAllA).then(function(values) {
                    resolve(userInputs);
                });
            });
        },

		// #2963
        updateThermalView:function(sValue){
            switch (sValue) {
                case "hotWater":
                    $("#am-hot-water-heatingSystem").addClass('hidden');
                    $("#am-hot-water-floors").addClass('hidden')
                    $("#am-hot-water-classeDPE").addClass('hidden')
                    $("#am-hot-water-boiler").removeClass('hidden')
                    break;
                case "combined":
                    $("#am-hot-water-floors").removeClass('hidden')
                    $("#am-hot-water-heatingSystem").removeClass('hidden')
                    $("#am-hot-water-classeDPE").removeClass('hidden')
                    $("#am-hot-water-boiler").addClass('hidden')
                    break;
                default:
                    break;
            }
        },

        getUserInputs: function() {
            // Initialize the output variable
            var userInputs = {
                hasElectricalHeating: false,
                hasElectricalBoiler: false,
                classeDPE:"D",// #2963
                heatingSystemType:"Electrique",// #2963
                simulateBankLoan: $('input[name=simulateBankLoan]').length === 0
            };

            // Get the form values (all the user inputs are contained in form elements)
            var $container = $(this._container);
            var formValues = $container.find('.smart-form:not(.am-rate-wrapper)').serialize();
            formValues.split('&').forEach(function(input) {
                var parts = input.split('=');
                var name  = parts[0];
                var value = isNaN(parts[1]) ? decodeURIComponent(parts[1]) : parseFloat(parts[1]); // use decode URI component to handle the case of drop-down lists with exotic symbols
                if(value=="on")
                    value =true;
                userInputs[name] = value;
            });

            // current setup type
            userInputs['setupType'] = this.getSetupType();

            // Bank loan own funds
            var $bankLoanForm = $('#bankLoanForm');
            if ($bankLoanForm.length > 0) {
                var $ownFundsInput = $bankLoanForm.find('input[name=creditPersonalFunds]');
                if ($ownFundsInput.length > 0) {
                    userInputs.creditPersonalFunds = parseFloat($ownFundsInput.val());
                }
            }

            var formKnobValues = $(this._container).find('form.am-rate-wrapper .am-rate-container .am-computation-result').each(function() {
                var _value = $(this).attr('data-value') || $(this).attr('value');
                var _name = $(this).attr('data-name') || $(this).attr('name');
                if (_value)
                    _value = parseInt(_value);
                userInputs[_name] = _value;
            });

            return userInputs;
        },

        getUserProfile: function() {
            return $('input[name="userCategory"]:checked').val();
        },

        getPanelElement: function() {
            return this._panelElementPromise;
        },

        getSliderElements: function() {
            return this._sliderElementsPromise;
        },

        getCurrentPageId: function() {
            return this._currPageId;
        },

        setCurrentPageId: function(currentPageId) {
            this._currPageId = currentPageId;

            // console.log(currentPageId);
            switch(currentPageId) {
                case 'am-electricity-production-results-section':
                    this.setSetupType('electricity-production');
                    break;
                case 'am-electricity-autoconsumption-results-section':
                    this.setSetupType('electricity-autoconsumption');
                    break;
                case 'am-hot-water-production-results-section':
                    this.setSetupType('hot-water');
                    break;
                default:
                    break;
            }

        },

        getSetupType: function() {
            return this._setupType;
        },

        setSetupType: function(setupType) {
            this._setupType = setupType;
        },

        _displayBreadCrumbButtons: function(previousPageIds, currPageId) {
            var $container = $(this._container);
            var $navbarItems = $container.find('nav li');
            $navbarItems.hide();

            if (currPageId != "am-home-section") {
                // Display the button corresponding to the current page
                var $currItem = $navbarItems.filter('[data-target="' + currPageId + '"]');
                $currItem.addClass('active');
                $currItem.show();

                // Display the previous button
                var $previous = $navbarItems.filter('[data-target="am-previous-section"]');
                $previous.show(); //('hidden');

                // Display the buttons of the preceeding pages
                if (previousPageIds) {
                    previousPageIds.forEach(function (pageId) {
                        var $item = $navbarItems.filter('[data-target="' + pageId + '"]');
                        $item.removeClass('active');
                        $item.show();
                    });
                }
            } else {
                // Display the previous button
                var $previous = $navbarItems.filter('[data-target="am-previous-section"]');
                $previous.hide();
                // $previous.addClass('hidden');
            }
        }
    });

    return module;

})(am || {});


//=============================================
// AM.UTILS NAMESPACE
//=============================================
am.utils = (function(module) {

    // Use strict mode
    'use strict';

    /**
     * Factory function returning an instance of am.InfoPanelView
     * 
     * @param {Object} options - Same options as for class L.Control
     * @return {am.InfoPanelView} - New instance of class am.InfoPanelView
     */
    module.infoPanelView = function(options) {
        return new am.InfoPanelView(options);
    };

    return module;

})(am.utils || {});